import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { THOUSAND_DELIMITER, FRACTIONAL_DELIMITER } from '../constants/number';
var NOT_NUMBER_REX = /[^0-9]/g;
var NUMBER_GROUP_REX = /.{1,3}/g;
export function formatNumber(value) {
  var _parseNumber = parseNumber(String(value)),
    fractional = _parseNumber.fractional,
    integer = _parseNumber.integer,
    sign = _parseNumber.sign;
  var parsedInteger = reverseString(integer).match(NUMBER_GROUP_REX) || [];
  var prettyInteger = parsedInteger.reverse().map(reverseString).join(THOUSAND_DELIMITER);
  return !fractional ? "".concat(sign).concat(prettyInteger) : "".concat(sign).concat(prettyInteger).concat(FRACTIONAL_DELIMITER).concat(fractional);
}
function reverseString(value) {
  return value.split('').reverse().join('');
}
function parseNumber(s) {
  var sign = s[0] === '-' ? '-' : '';
  var _s$split = s.split('.'),
    _s$split2 = _slicedToArray(_s$split, 2),
    integer = _s$split2[0],
    fractional = _s$split2[1];
  return {
    fractional: fractional ? fractional.replace(NOT_NUMBER_REX, '') : '',
    integer: integer.replace(NOT_NUMBER_REX, ''),
    sign: sign
  };
}